// The scene in seconds after it starts. The car (ThxCar), the smoke (ThxSmoke) and the number (ThxCounter) are timed on this.

// The car races in, brakes, stands still and drives off. Its keyframes brake at 28% and stand still until 62%.
export const DRIVE_SECONDS = 2.6
export const BRAKE_START = DRIVE_SECONDS * 0.28

// The smoke starts to clear from here, left to right, and is gone about a second later.
export const SMOKE_CLEAR_START = 3.5

// The number is put in place when the smoke is at its thickest, and lights up once the last smoke is gone.
export const PLACE_NUMBER_AT = 2.7
export const LIGHT_ON_AT = SMOKE_CLEAR_START + 1
